import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Licensely (Commercial Project)',
        projectDesc: 'Help users to learn about driving ',
        tags: ['React Native', 'Firebase', 'Material Ui', ],
        code: '#',
        demo: '#',
        image: one
    },
    {
        id: 2,
        projectName: 'Superior Weather (Commercial Project)',
        projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
        tags: ['React Native', 'Google Maps API', 'Material Ui', ],
        code: 'https://github.com/WhoAbdullahSheikh/SuperiorWeather',
        demo: '#',
        image: two
    },
    {
        id: 3,
        projectName: 'Naviq Management System',
        projectDesc: 'A smart ride management system for users to book a ride and track their ride.',
        tags: ['React Native', 'Firebase', 'Google Maps API', 'Material Ui', ],
        code: 'https://github.com/WhoAbdullahSheikh/Smart-Ride-Managment-Advance-',
        demo: '#',
        image: three
    },
    {
        id: 4,
        projectName: 'Wonderland Clothing',
        projectDesc: 'A Simple E-commerce application',
        tags: ['PHP', 'HTML5', 'CSS', 'JavaScript', 'Firebase'],
        code: 'https://github.com/WhoAbdullahSheikh/Wonderland-Clothing',
        demo: '#',
        image: four
    },
    {
        id: 5,
        projectName: 'EasyTrack',
        projectDesc: 'A Smart Book Ride Application for users to book a ride and track their ride for university students.',
        tags: ['React Native', 'Firebase', 'Google Maps API', 'Material Ui', ],
        code: 'https://github.com/WhoAbdullahSheikh/EasyTrack',
        demo: '#',
        image: five
    },
    {
        id: 6,
        projectName: 'Fiver Lite',
        projectDesc: 'Fiver Clone',
        tags: ['React Native', 'Firebase', 'Material Ui'],
        code: 'https://github.com/WhoAbdullahSheikh/PkFiverr',
        demo: '#',
        image: six
    },
    {
        id: 7,
        projectName: 'Automated Authorization System',
        projectDesc: 'An automated authorization system for users to authorize their registeration of account.',
        tags: ['Python', 'Robot Framework', 'Selenium', 'React JS'],
        code: 'https://github.com/WhoAbdullahSheikh/AutomatedBot',
        demo: '#',
        image: seven
    },
    {
        id: 8,
        projectName: 'TodoList',
        projectDesc: 'A Todo List application for users to add, edit and delete their tasks.',
        tags: ['React Native', 'Firebase', 'Material Ui'],
        code: 'https://github.com/WhoAbdullahSheikh/TodoList-Android',
        demo: '#',
        image: eight
    },
]


